import { apiNoAuth } from "./conection";

export const WebSiteSettingsService = {
  getAllSettings: async () => {
    const response = await apiNoAuth.get("/site-settings/");
    console.log(response.data);
    return response.data;
  },
};
